import SiteHeader from "@/components/common/SiteHeader";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";

const Privacy = () => (
  <div className="flex flex-col w-full">
    <SiteHeader header="Privacy Policy" />
    <div className="px-10 py-8">
      <h1 className="text-xl font-bold">Privacy Policy</h1>
      <div className="py-4">
        <p className="font-bold">Last updated: April 2, 2024</p>
        <p>
          {`This Privacy Policy outlines how Carbon Clear ("we", "our", or "us")
          collects, uses, and protects the information of the users ("you" or
          "your") and site visitors, including third parties who have authorized
          sharing of building data with our users. `}
        </p>
      </div>

      <div className="py-4">
        <h2>Consent</h2>
        <p>
          By using our Service, you consent to the collection and use of
          information in accordance with this policy.
        </p>
      </div>

      <div className="py-4">
        <h2>Information We Collect</h2>
        <p>
          We may collect personal identification information from Users in a
          variety of ways, including, but not limited to, when Users visit our
          site, register on the site, fill out a form, or authorize integration
          with a third party service, as well as in connection with other
          activities, services, features, or resources we make available on our
          Service.
        </p>
      </div>

      <div className="py-4">
        <h2>How We Use Your Information</h2>
        <ul>
          <li>To personalize user experience</li>
          <li>To provide analyses and views of the data to users</li>
          <li>To improve our Service</li>
          <li>To process payments</li>
          <li>To send emails</li>
        </ul>
      </div>

      <div className="py-4">
        <h2>Sharing Your Personal Information</h2>
        <p>
          {`We do not sell, trade, or rent Users' personal identification
          information to others. We may share generic aggregated information not
          linked to any personal identification information regarding visitors
          and users with our business partners and trusted affiliates for the
          purposes outlined above.`}
        </p>
      </div>

      <div className="py-4">
        <h2>Your Rights Over Your Data</h2>
        <p>
          You have the right to access, update, or delete the information we
          have on you. When made possible, you can access, update or request
          deletion of your Personal Information directly within your account
          settings section. If you are unable to perform these actions yourself,
          please contact us at{" "}
          <a href="mailto:support@getcodeclear.com">
            support@getcodeclear.com
          </a>
        </p>
      </div>

      <div className="py-4">
        <h2>Security</h2>
        <p>
          We are committed to ensuring that your information is secure. In order
          to prevent unauthorized access or disclosure, we have put in place
          suitable physical, electronic, and managerial procedures to safeguard
          and secure the information we collect online.
        </p>
      </div>

      <div className="py-4">
        <h2>Changes to This Privacy Policy</h2>
        <p>
          Carbon Clear has the discretion to update this privacy policy at any
          time. When we do, we will revise the updated date on this page. We
          encourage Users to frequently check this page for any changes to stay
          informed about how we are helping to protect the personal information
          we collect.
        </p>
      </div>

      <div className="py-4">
        <h2>Contacting Us</h2>
        <p>
          If you have any questions about this Privacy Policy, the practices of
          this site, or your dealings with this site, please contact us at{" "}
        </p>
        <p>
          <a href="mailto:support@getcodeclear.com">
            support@getcodeclear.com
          </a>
        </p>
      </div>
    </div>
  </div>
);
export const Route = createFileRoute("/policies/privacy")({
  component: Privacy,
});
